import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomeApp from "./HomeApp";
import MenottiApp from "./MenottiApp";
import MenottiInfoApp from "./MenottiInfoApp";
import CMCalendarApp from "./CMCalendarApp";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeApp />} />
        <Route path="/menotti" element={<MenottiApp />} />
        <Route path="/menotti_contatti" element={<MenottiInfoApp />} />
        <Route path="/cm_calendar" element={<CMCalendarApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
